import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col
} from "reactstrap";

// core components

function SectionBlog(props = {}) {
  const { cookies, form, webimageArr } = props;
  const { text2 = '', text3 = '' } = form;
  const dbLang = cookies.get('dbLang') || 'name';

  let arr = []
  arr = webimageArr.filter(item => item.navId === form.objectId)
  if (!arr.length) {
    arr = [{ icon: "nc-app", title1name: "標題", content1name: '內文' },
    { icon: "nc-app", title1name: "標題", content1name: '內文' },
    { icon: "nc-app", title1name: "標題", content1name: '內文' },
    { icon: "nc-app", title1name: "標題", content1name: '內文' }]
  }
  return (
    <>
      <div className="blog-3" style={{ margin: '200px 0px' }}>
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" md="10">
              <h2 className="title" style={{ fontSize: '40px', textAlign: 'center' }}>愛知国際学院とは</h2>
              <br />
              {arr.map((item, index) => <>
                {index % 2 === 0 ?
                  <Card className="card-plain card-blog">
                    <Row>
                      <Col md="4" xs="4">
                        <div className="card-image">
                          <img
                            alt="..."
                            className="img"
                            style={{ width: '100%', height: '183.13px' }}
                            src={(item.file1 && item.file1.url) || require("assets/img/sections/jeff-sheldon.jpg")}
                          />
                        </div>
                      </Col>
                      <Col md="8" xs="8">
                        <CardBody>
                          {/* <h6 className="card-category text-info">Enterprise</h6> */}
                          <CardTitle tag="h3">
                            <a style={{ fontFamily: 'PMingLiU', fontSize: '22px', fontWeight: '400', color: `${index % 4 ? '#6BD197' : '#50BDDA'}` }} href="#pablo" onClick={e => e.preventDefault()}>
                              {item['title1' + dbLang] || ''}
                            </a>
                          </CardTitle>
                          <p className="card-description">
                            {/* {item['content1' + dbLang] || ''} */}
                            {item['content1' + dbLang] || ''}
                            {/* No matter what happens — funding versus acquisition
                            versus who knows what — Ljung says SoundCloud is not
                            going away “anytime in the foreseeable future.” I hope
                            that’s true, but I can’t help but feel a bit
                          skeptical. — and…{" "}
                            <a href="#pablo" onClick={e => e.preventDefault()}>
                              Read More
                          </a>
                          </p>
                          <p className="author">
                            by{" "}
                            <a href="#pablo" onClick={e => e.preventDefault()}>
                              <b>Megan Rose Dickey</b>
                            </a>
                          , 11 days ago */}
                          </p>
                          {/* <p className="author">
                            by{" "}
                            <a href="#pablo" onClick={e => e.preventDefault()}>
                              <b>Megan Rose Dickey</b>
                            </a>
                          , 11 days ago
                          </p> */}
                        </CardBody>
                      </Col>
                    </Row>
                  </Card> :
                  <Card className="card-plain card-blog">
                    <Row>
                      <Col md="8" xs="8">
                        <CardBody>
                          {/* <h6 className="card-category text-danger">
                            <i className="fa fa-free-code-camp mr-1" />
                          Trending
                        </h6> */}
                          <CardTitle tag="h3">
                            <a style={{ fontFamily: 'PMingLiU', fontSize: '22px', fontWeight: '400', color: `${index % 3 ? '#F7C23C' : '#F55A3D'}` }} href="#pablo" onClick={e => e.preventDefault()}>
                              {item['title1' + dbLang] || ''}
                            </a>
                          </CardTitle>
                          <p className="card-description">
                            {/* {item['content1' + dbLang] || ''} */}
                            {item['content1' + dbLang] || ''}
                            {/* These issues might be making it a bit harder for Uber
                            to hire right now in the competitive Silicon Valley
                            job market. Acqui-hiring companies like it’s doing
                            here with Swipe Labs lets it roll up a bunch of good
                          talent — and…{" "}
                            <a href="#pablo" onClick={e => e.preventDefault()}>
                              Read More
                          </a>
                          </p>
                          <p className="author">
                            by{" "}
                            <a href="#pablo" onClick={e => e.preventDefault()}>
                              <b>Josh Constine</b>
                            </a>
                          , 2 days ago */}
                          </p>
                          {/* <p className="author">
                            by{" "}
                            <a href="#pablo" onClick={e => e.preventDefault()}>
                              <b>Megan Rose Dickey</b>
                            </a>
                          , 2 days ago
                          </p> */}
                        </CardBody>
                      </Col>
                      <Col md="4" xs="4">
                        <div className="card-image">
                          <a href="#pablo" onClick={e => e.preventDefault()}>
                            <img
                              alt="..."
                              className="img"
                              style={{ width: '100%', height: '183.13px' }}
                              src={(item.file1 && item.file1.url) || require("assets/img/sections/rawpixel-comm.jpg")}
                            />
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </Card>}
              </>)}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default SectionBlog;